import React from "react";
import Popup from "../Component/Popup";
import HomeSlider from "../Component/HomeSlider";
import ISCToppers from "./results/ISCToppersXII";
import TopperX from "../Component/ICSETopperHome";
import Events from "../Component/Events";
import News from "../Component/News";
import Calendar from "../Component/Calendar";
import Campuscare from "../Component/Campuscare";
import OnlineRegistration from "../Component/OnlineRegistration";
// import Facilities from'../Component/Facilities'
import Gallery from "../Component/Gallery";
import Message from "../Component/Message";
import { Link } from "react-router-dom";
import ClassTabs from "../Component/ClassTabs";
import FacebookPagePlugin from "../Component/Facebook";
import Instagram from "../Component/Instagram";
import YouTubeWidget from "../Component/YouTubewidget";
import Header from "../Component/Header";
import LazyLoad from "react-lazyload";
import ICSETopperHome from "../Component/ICSETopperHome";
import ISCTopperHome from "../Component/ISCTopperHome";
const Home = () => {
  return (
    <>
      <Campuscare />
      <Popup />
      <OnlineRegistration />
      <HomeSlider />
      <div className="aboutmidsec padded-sec">
        <div className="button">
          <Link to="/disclosure" target="_blank">
            <p>CBSE Disclosure</p>
          </Link>
        </div>
        <div className="button">
          <Link to="/" target="_blank">
            <p>Online Payment</p>
          </Link>
        </div>
        <div className="button">
          <Link to="/" target="_blank">
            <p>Alumnae Registration</p>
          </Link>
        </div>
        <div className="phone">
          <a href="tel:0657-2284061">
            <LazyLoad>
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/phone.gif"
                alt="St. Joseph’s school, Barhalganj"
              />
            </LazyLoad>
          </a>
        </div>
        <div className="button">
          <Link to="/">
            <p>bus route</p>
          </Link>
        </div>
        <div className="button">
          <Link to="/">
            <p> Gallery</p>
          </Link>
        </div>
        <div className="button">
          <Link to="/" target="_blank">
            <p>ERP Login</p>
          </Link>
        </div>
      </div>
      <div className="aboutsec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className="col-lg-6 about-bg">
              <div class="about-news">
                <div className="title">
                  <p>about us</p>
                  <h2>St. Joseph’s school, Barhalganj</h2>
                </div>
                <p>
                  <strong>St. Joseph’s school, Barhalganj</strong>, affiliated
                  to the central board of secondary education, New Delhi (aff.
                  no. 2131498) is an English medium Christian minority
                  educational institution established in 2007, administered and
                  governed by the Catholic diocese of Gorakhpur education
                  society, registered under the society's registration act.
                  Being governed by the Catholic church a minority community,
                  the school has the primary objective of educating the children
                  of the community. However, we shall not spare any effort in
                  rendering our service to all people, irrespective of caste and
                  gender, so as to conserve their religion, language and
                  culture.
                </p>

                <Link to="/about">
                  <button className="button">Read More</button>
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-img">
                <div className="abt_abs abs-img1">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/about1.jpg"
                      alt="St. Joseph’s school, Barhalganj"
                    />
                  </LazyLoad>
                </div>
                <div className="abt_abs abs-img2">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/about2.jpg"
                      alt="St. Joseph’s school, Barhalganj"
                    />
                  </LazyLoad>
                </div>
                <div className="center-img">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/aboutimg.png"
                      className="abs-img3"
                      alt="St. Joseph’s school, Barhalganj"
                    />
                  </LazyLoad>
                </div>
                <div className="abt_abs abs-img4">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/about3.jpg"
                      alt="St. Joseph’s school, Barhalganj"
                    />
                  </LazyLoad>
                </div>
                <div className="abt_abs abs-img5">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/about4.jpg"
                      alt="St. Joseph’s school, Barhalganj"
                    />
                  </LazyLoad>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="classSection">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <ClassTabs />
            </div>
          </div>
        </div>
      </div> */}
      <div className="calender">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title">
                <h2>ACADEMIC CALENDAR</h2>
              </div>
              <Calendar />
            </div>
          </div>
        </div>
      </div>
      <div className="event">
        <div className="container fulwidth">
          <div className="row">
            <div className="col-lg-12 section-title">
              <div className="title">
                <h2>FROM THE DESK OF</h2>
              </div>
            </div>
            <div className="col-lg-12">
              <Message />
            </div>
          </div>
        </div>
      </div>
      <div className="events padded-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-6 col-md-12">
              <div className="title">
                <h2>Events section</h2>
              </div>
              <Events />
            </div>
            <div className="col-xl-6 col-md-12">
              <div className="title">
                <h2>Latest News/Announcement</h2>
              </div>
              <News />
            </div>
          </div>
        </div>
      </div>
      <div className="topper_bg padded-sec">
        <div className="container-fluid section-title">
          <div className="row">
            <div className="col-md-12">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/topper.png"
                  className="img-fluid m-auto d-block"
                />
              </LazyLoad>
            </div>
            <div className="col-lg-6">
              <div className="topper-block">
                <div className="title">
                  <h2>ICSE Toppers</h2>

                  <div className="arrrow-btn">
                    {/* <Link to="/">
                    <i class="bi bi-chevron-right"></i></Link>*/}
                  </div>
                </div>
                <ICSETopperHome></ICSETopperHome>
              </div>
              <button className="button">
                <Link to="/ISCEToppers">View all</Link>
              </button>
            </div>

            <div className="col-lg-6">
              <div className="topper-block">
                <div className="title">
                  <h2>ISC Toppers</h2>
                  <div className="arrrow-btn">
                    {/* <Link to="/">
                    <i class="bi bi-chevron-right"></i>
                  </Link> */}
                  </div>
                </div>
                <ISCTopperHome></ISCTopperHome>
              </div>
              <button className="button">
                <Link to="/ISCToppers">View all</Link>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <LazyLoad>
        <img
          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/shape.png"
          className="wid-100"
        />
      </LazyLoad> */}

      <div className="homegallery padded-sec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className="col-md-12 section-title">
              <div className="title">
                <h2>Activities in Images</h2>
              </div>
            </div>
            <div className="col-lg-12">
              <Gallery />
            </div>
          </div>
        </div>
      </div>
      <div className="contact_homepg padded-sec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className="col-md-12">
              <div className="upper-ftr">
                <h3>
                  Knowledge is Power,
                  <br /> Learn to Lead Tomorrow
                </h3>
                <div className="call-blk">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/call-icon.png"
                    alt="St. Joseph’s school, Barhalganj"
                  />
                  <div>
                    <p>Reach Out Now</p>
                    <h3>XXX-XXXXXXXX</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
